<template>
  <v-btn
    outlined
    color="#1D6F42"
    v-bind="size"
    @click="onClick"
    :loading="isLoading"
  >
    <v-icon color="#1D6F42">mdi-file-excel</v-icon>
  </v-btn>
</template>

<script>
export default {
  props: ['onClick', 'size', 'isLoading'],
};
</script>
